import { Scenarios } from '@jfs/network'

const generateOtp = {
  default: [
    {
      url: /authenticate/,
      method: 'POST',
      body: /agentAuth/,
      response: {
        status: 'SUCCESS',
        bankCustomerId: 56954336,
        authorizationCode: 'a82162c0-21fc-41e9-80c0-9e90e8fa37a5',
      },
      delay: 500,
    },
    {
      url: /authenticate/,
      method: 'POST',
      body: /biometrics/,
      response: {
        status: 'SUCCESS',
        session: {
          accessToken: {
            tokenValue: '62adce0c-390e-481b-bd54-f3291c0979c8USERACCESS',
            expiresIn: 3600,
          },
          refreshToken: {
            tokenValue: 'a5ec0af1-9533-4b1a-8379-9953b6ca733fUSERREFRESH',
            expiresIn: 604800,
          },
          userIdentifierToken: 'biouserIdentifierTokeni9879',
        },
        aadhaar: {
          UIDToken: '123asdfra123123123asdfas232342342asdfsd24233232adsfsdf1242343sadfs234324',
          referenceNumber: 'e2342-2343-sdfd-2134',
          jpbToken: 'a82162c0-21fc-41e9-80c0-9e90e8fa37a5',
        },
      },
      delay: 500,
    },
    {
      url: /authenticate/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
        session: {
          accessToken: { tokenValue: '312908f5-f52f-4755-8085-a69517ba3fdcUSERACCESS', expiresIn: 60 },
          refreshToken: { tokenValue: '8ba27564-6864-4882-8231-3dca8a42b224USERREFRESH', expiresIn: 607753 },
          userIdentifierToken: 'ut78u686abc33345htag',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /authenticate/,
      method: 'POST',
      responseCode: 5000,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { generateOtp }
